/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
/// ID of the machines folder defined by machinery. E.g. all machines from MachineTools have this folder as a parent.
export const MachineryMachinesId = 'nsu=http:_2F_2Fopcfoundation.org_2FUA_2FMachinery_2F;i=1001';
